import React, {Component} from "react"
import {Row, Col} from "@irati/ui/src/Layout"
import * as PropTypes from "prop-types"

import id from "@irati/utils/id"
import {CompanyValue} from "@irati/types"
import authentication from "@irati/auth"
import {Body, H1} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"

import FullModal from "../../components/FullModal"
import {CompanyValuesCreateEdit, CompanyValuesList} from "../../components/Settings/CompanyValues"

interface Props {
  setupView?: boolean
  setIsStepCompletable?: (value: boolean) => void
}

interface State {
  show: boolean
  companyValue: CompanyValue
}

class CompanyValuesBasic extends Component<Props, State> {
  static contextTypes = {
    apps: PropTypes.object.isRequired
  }

  state: State = {
    show: false,
    companyValue: null
  }

  show = (companyValue) => {
    this.setState({show: true, companyValue})
  }

  hide = () => {
    const {setupView, setIsStepCompletable} = this.props
    if (setupView && setIsStepCompletable) {
      setIsStepCompletable(true)
    }
    this.setState({show: false, companyValue: null})
  }

  render() {
    const {setupView} = this.props
    const {show, companyValue} = this.state
    const idNamespace = id("company-values-basic", this.props)
    const isCompanyValuesEnabled = authentication.apps("platform.companyValues")

    return (
      <>
        {isCompanyValuesEnabled ? (
          <Row>
            <Col md={11}>
              <div id={idNamespace}>
                <CompanyValuesList setupView={setupView} onClick={this.show} />
                <FullModal id={idNamespace} onHide={this.hide} show={show}>
                  <CompanyValuesCreateEdit onSuccess={this.hide} companyValue={companyValue} />
                </FullModal>
              </div>
            </Col>
          </Row>
        ) : (
          <>
            <H1 marginBottom={4}>
              <FormattedMessage id="admin.companyValues.nav.header" />
            </H1>
            <Body>
              <FormattedMessage id="admin.companyValues.nav.celebrationHubDisabled.p1" />
            </Body>
            <Body marginTop={2}>
              <FormattedMessage id="admin.companyValues.nav.celebrationHubDisabled.p2" />
            </Body>
          </>
        )}
      </>
    )
  }
}

export default CompanyValuesBasic
